/**
 * DevExtreme (esm/ui/data_grid.js)
 * Version: 25.1.6
 * Build date: Mon Oct 13 2025
 *
 * Copyright (c) 2012 - 2025 Developer Express Inc. ALL RIGHTS RESERVED
 * Read about DevExtreme licensing here: https://js.devexpress.com/Licensing/
 */
import DataGrid from "../__internal/grids/data_grid/m_widget";
import FilterBuilder from "./filter_builder";
export default DataGrid;